import React from "react";
import { Download } from "lucide-react";
import CustomTooltip from "../CustomTooltip";

const KYBReportDownload = ({ kyb_report_file, setLoading }) => {
  const handleDownloadKYB = async (fileUrl) => {
    try {
      setLoading(true);

      const export_report_path = fileUrl;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        // ✅ ADD THIS LINE FOR SAFARI
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      <CustomTooltip message={"UBO Report"}>
        <span>
          <Download
            size={18}
            onClick={(e) => {
              e.preventDefault();
              handleDownloadKYB(kyb_report_file);
            }}
          />
        </span>
      </CustomTooltip>

      <span>/</span>
    </>
  );
};

export default KYBReportDownload;
